/**
 * Subscribe to WebSocket events for a project. The backend streams one
 * JobEvent per project-scoped action (transcribe/translate/diarize/burn).
 *
 * Returns a disposer that closes the socket.
 */
import { API_BASE } from "./api";

export function connectProjectWS(projectId, onEvent, onStatus) {
  // Reuse the smart backend URL resolved by api.js so WS stays same-origin
  // on custom-domain deployments (cookies travel along with the upgrade
  // request that way).
  const wsUrl = API_BASE.replace(/^http/i, "ws").replace(/\/api$/, "") + `/api/ws/projects/${projectId}`;
  let ws;
  let closed = false;
  let retries = 0;

  const connect = () => {
    if (closed) return;
    ws = new WebSocket(wsUrl);
    onStatus && onStatus("connecting");
    ws.onopen = () => { retries = 0; onStatus && onStatus("open"); };
    ws.onmessage = (ev) => {
      try {
        const data = JSON.parse(ev.data);
        if (data && data.type === "ping") return; // keepalive
        onEvent && onEvent(data);
      } catch (err) {
        console.warn("[ws] failed to parse message", err);
      }
    };
    ws.onclose = () => {
      onStatus && onStatus("closed");
      if (!closed && retries < 5) {
        retries += 1;
        setTimeout(connect, Math.min(5000, 500 * 2 ** retries));
      }
    };
    ws.onerror = () => { onStatus && onStatus("error"); };
  };
  connect();

  return () => {
    closed = true;
    try { ws && ws.close(); } catch (err) { console.warn("[ws] close failed", err); }
  };
}
